import { getCardStyles, getEyebrowStyles } from '../themes/themeExtensions'

// Entity header: a panel with an uppercase display title and eyebrow metadata
export const getEntityHeaderStyles = (theme) => ({
  container: {
    ...getCardStyles(theme).root,
    p: 3,
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    color: theme.palette.text.primary,
  },
  eyebrow: getEyebrowStyles(theme),
})
